import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import Image from "@tiptap/extension-image";

export const composeEditorExtensions = [
  StarterKit,
  Link.configure({ openOnClick: true }),
  Image.configure({
    inline: true,
    allowBase64: true,
  }),
];
